import React from 'react';
import { View } from 'react-native';
import { Subtitle, Text } from 'app/src/styles';

import ExternalLink from 'app/src/elements/ExternalLink';

const About = () => {
  return (
    <View>
      <Text>
        oklahomatemptag.com es un portal para que los concesionarios de
        automóviles con licencia de Oklahoma preinscriban sus ventas
        de vehículos de acuerdo con la Ley SB2035, también conocida como
        la Ley Mason Treat. Para obtener más información sobre el
        preinscripción o si es usted un consumidor, visite:{' '}
        <ExternalLink url="http://readysettag.com">
          <Text>ReadySetTag.com</Text>
        </ExternalLink>
      </Text>
    </View>
  );
};

export default About;
